'use client';

import { c as _c } from "react/compiler-runtime";
import { type FactiiiTag, type SpaceTimeTag, wallClockOf } from '@shared/all/domains/factiiis';
import { useFactiiiHandlers } from '@shared/utils/hooks/useFactiiiHandlers';
import { Trash } from 'lucide-react';
import { useState } from 'react';
import TimezoneSelect from 'react-timezone-select';
import Button from '../../common/Button';
type Props = {
  dateSaveHandler: (date: string | undefined, time: string | undefined, timezone: SpaceTimeTag['timezone'] | undefined) => void;
  triggerRemove: () => void;
  defaultTimezone: {
    value: string;
    label: string;
    offset: number;
  };
  tag: FactiiiTag;
  disabled?: boolean;
};
const DefaultDateTimeFactiii = t0 => {
  const $ = _c(56);
  const {
    dateSaveHandler,
    defaultTimezone,
    tag,
    disabled,
    triggerRemove
  } = t0;
  const spaceTime = tag.postFactiiis[0].spaceTimes?.[0];
  const startTimezone = spaceTime?.timezone || defaultTimezone;
  let t1;
  if ($[0] !== spaceTime || $[1] !== startTimezone) {
    t1 = spaceTime?.timestamp ? wallClockOf(spaceTime.timestamp, startTimezone.offset) : null;
    $[0] = spaceTime;
    $[1] = startTimezone;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const startWallClock = t1;
  const [date, setDate] = useState(startWallClock ? startWallClock.date : spaceTime?.date || "");
  const [time, setTime] = useState(startWallClock ? startWallClock.time : spaceTime?.time || "");
  const [timezone, setTimezone] = useState(startTimezone);
  const {
    validateDateTime
  } = useFactiiiHandlers();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const now = new Date();
      const timezoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezone_0 = {
        value: timezoneValue,
        label: timezoneValue.replace(/_/g, " "),
        offset: now.getTimezoneOffset() / -60
      };
      const {
        date: date_0,
        time: time_0
      } = wallClockOf(now, timezone_0.offset);
      setTimezone(timezone_0);
      setDate(date_0);
      setTime(time_0);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSetNow = t2;
  let t3;
  if ($[4] !== date || $[5] !== time || $[6] !== timezone || $[7] !== validateDateTime) {
    t3 = validateDateTime(date, time, timezone);
    $[4] = date;
    $[5] = time;
    $[6] = timezone;
    $[7] = validateDateTime;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isValidDateTime = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setDate(e_0.target.value);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== date || $[11] !== disabled) {
    t5 = <input id="datePicker" title="Date Chooser" type="date" className="w-full rounded-md border border-ds-border-standard bg-background-secondary p-2 text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary" value={date} disabled={disabled} onChange={t4} />;
    $[10] = date;
    $[11] = disabled;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_1 => setTime(e_1.target.value);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== disabled || $[15] !== time) {
    t7 = <input id="timePicker" title="Time Chooser" type="time" className="w-full rounded-md border border-ds-border-standard bg-background-secondary p-2 text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary" value={time} onChange={t6} disabled={disabled} />;
    $[14] = disabled;
    $[15] = time;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="flex items-center space-x-2">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = selectedTimezone => {
      if (typeof selectedTimezone === "string") {
        setTimezone({
          value: selectedTimezone,
          label: selectedTimezone,
          offset: 0
        });
      } else {
        setTimezone({
          value: selectedTimezone.value,
          label: selectedTimezone.label,
          offset: selectedTimezone.offset ?? 0
        });
      }
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      control: _temp2,
      menu: _temp3,
      option: _temp4,
      singleValue: _temp5
    };
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== disabled || $[23] !== timezone) {
    t11 = <div className="text-textPrimary"><TimezoneSelect onChange={t9} value={timezone} styles={t10} isDisabled={disabled} /></div>;
    $[22] = disabled;
    $[23] = timezone;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== date || $[26] !== dateSaveHandler || $[27] !== time || $[28] !== timezone) {
    t12 = () => {
      dateSaveHandler(date, time, timezone);
    };
    $[25] = date;
    $[26] = dateSaveHandler;
    $[27] = time;
    $[28] = timezone;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = disabled || !isValidDateTime;
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <Button type="button" classNames="w-full" borderTransparent={false} text="Save" onClick={t12} disabled={t13} />;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => handleSetNow();
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== disabled) {
    t16 = <Button variant="SECONDARY" type="button" classNames="w-full" borderTransparent={false} text="Now" onClick={t15} disabled={disabled} />;
    $[34] = disabled;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== tag.isNewFactiii || $[37] !== tag.isRemovedFactiii || $[38] !== triggerRemove) {
    t17 = !tag.isNewFactiii && <Button variant="CLEAR" classNames={`p-1.5 ml-auto ${tag.isRemovedFactiii ? "border-destructive" : ""}`} borderTransparent={false} icon={<Trash width={20} height={20} color={tag.isRemovedFactiii ? "red" : "rgba(var(--text-secondary-color))"} />} tooltip={tag.isRemovedFactiii ? "Marked for removal" : "remove"} onClick={e_2 => {
      e_2.stopPropagation();
      triggerRemove();
    }} />;
    $[36] = tag.isNewFactiii;
    $[37] = tag.isRemovedFactiii;
    $[38] = triggerRemove;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== dateSaveHandler || $[41] !== defaultTimezone || $[42] !== tag.isNewFactiii) {
    t18 = tag.isNewFactiii && <Button variant="CLEAR" classNames="p-1.5 ml-auto" borderTransparent={false} text="Clear" tooltip="Clear the inputs" onClick={e_3 => {
      e_3.stopPropagation();
      setDate("");
      setTime("");
      setTimezone(defaultTimezone);
      dateSaveHandler(undefined, undefined, undefined);
    }} />;
    $[40] = dateSaveHandler;
    $[41] = defaultTimezone;
    $[42] = tag.isNewFactiii;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t14 || $[45] !== t16 || $[46] !== t17 || $[47] !== t18) {
    t19 = <div className="flex items-center space-x-2">{t14}{t16}{t17}{t18}</div>;
    $[44] = t14;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== isValidDateTime) {
    t20 = !isValidDateTime && <><p className="mt-2 text-destructive">Please enter valid date/time</p></>;
    $[49] = isValidDateTime;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t11 || $[52] !== t19 || $[53] !== t20 || $[54] !== t8) {
    t21 = <div onClick={_temp} className="space-y-2">{t8}{t11}{t19}{t20}</div>;
    $[51] = t11;
    $[52] = t19;
    $[53] = t20;
    $[54] = t8;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
};
export default DefaultDateTimeFactiii;
function _temp(e) {
  e.stopPropagation();
}
function _temp2(base) {
  return {
    ...base,
    backgroundColor: "rgba(var(--background-secondary-color))",
    borderColor: "rgba(var(--border-color))",
    color: "rgba(var(--text-color))"
  };
}
function _temp3(base_0) {
  return {
    ...base_0,
    backgroundColor: "rgba(var(--background-secondary-color))"
  };
}
function _temp4(styles, t0) {
  const {
    isFocused,
    isSelected
  } = t0;
  return {
    ...styles,
    backgroundColor: isSelected ? "rgba(var(--primary))" : isFocused ? "rgba(var(--hover-color))" : "rgba(var(--background-secondary-color))",
    color: "rgba(var(--text-color))",
    ":active": {
      ...styles[":active"],
      backgroundColor: "rgba(var(--primary))"
    }
  };
}
function _temp5(base_1) {
  return {
    ...base_1,
    color: "rgba(var(--text-color))"
  };
}